import { requestApi } from 'api/Api';

export const createPracticeWizard = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/create',
    method: 'POST',
    params,
    navigate
  });
};

export const getPracticeBasicSetup = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/basic_setup/get',
    method: 'POST',
    params,
    navigate
  });
};

export const updatePracticeBasicSetup = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/basic_setup/update',
    method: 'POST',
    params,
    navigate
  });
};

export const deriveMotionSteps = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/derive_motion',
    method: 'POST',
    params,
    navigate
  });
};

export const startPracticeSetup = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/practice/start_setup',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardInstanceById = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/get',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardProgressInstanceById = (navigate, params) =>
  requestApi({
    url: '/api/wizard/instance/progress',
    method: 'POST',
    params,
    navigate
  });

export const getObligationsLog = (navigate, params) =>
  requestApi({
    url: '/api/wizard/instance/obligations_log',
    method: 'POST',
    params,
    navigate
  });

export const submitWizardOrchestrator = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/wizard/orchestrator',
    params,
    timeout: 45000
  });
};

export const getTrainingVideoOptions = (navigate, params) =>
  requestApi({
    url: '/api/admin/wizard/training_videos',
    params,
    navigate
  });

export const getWizardOverview = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/instance/overview',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardInstanceDelegation = (navigate, params) => {
  return requestApi({
    navigate,
    url: '/api/wizard/instance/get_delegation',
    params
  });
};

export const delegateTasksForStaff = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/wizard/instance/delegate',
    params
  });

export const principalConfirm = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/wizard/instance/principal_approval',
    params
  });

export const getWizardTemplate = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/template/get',
    method: 'POST',
    params,
    navigate
  });
};

export const saveWizardTemplate = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/template/save',
    method: 'POST',
    params,
    navigate
  });
};

export const deleteWizardTemplate = (navigate, params) => {
  return requestApi({
    url: '/api/admin/wizard/template/delete',
    method: 'POST',
    params,
    navigate
  });
};

export const getWizardDynamicSteps = (navigate, params) => {
  return requestApi({
    url: '/api/wizard/dynamic_step/get',
    method: 'POST',
    params,
    navigate
  });
};
